import eventEmitter from './eventEmitter';
import { flattenObject } from '../utils/flatten';
import Store from '../utils/store';

export default (function () {
    var build = function () {
        this.eventEmitter = eventEmitter;
        this.lngDictionnary = {};
        this.setDictionnary = dic => { dictionnary = flattenObject(dic) };
        this.getTradByKey = key => (typeof (dictionnary[key]) === 'undefined') ? `crew-app.${key}` : dictionnary[key];
        this.airportsNameStore = new Store();
        this.setAuthCredencials = (authObj) => Object.keys(authObj).map((key) => localStorage.setItem(key, authObj[key]));
        this.clearAuth = () => {
            localStorage.clear()
        };
        this.content_roles = [];
        this.authCredencials = {
            token: () => localStorage.getItem('token'),
            registrationNumber: () => localStorage.getItem('registrationNumber'),
            iataFrom: () => localStorage.getItem('iataFrom'),
            iataTo: () => localStorage.getItem('iataTo')
        }
    }
    var instance = null;
    var dictionnary = {};
    return new function () {
        this.getInstance = function () {
            if (instance == null) {
                instance = new build();
                instance.build = null;
            }
            return instance;
        }
    }
})();